import type { SxProps, Theme } from '@mui/material/styles';

/** A static, semantic label shared by Cockpit form controls. */
export const cockpitFieldLabelSx: SxProps<Theme> = {
  display: 'block',
  m: 0,
  mb: '4px',
  px: '4px',
  color: 'var(--cockpit-text-muted)',
  fontFamily: 'var(--cockpit-font-body) !important',
  fontSize: '12px !important',
  lineHeight: '16px !important'
};
